import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const appStore = new Vuex.Store({
  state: {
  },
  mutations: {
  }
})
